/**
 * Parses the admin SPA's spending-limit input field.
 *
 * Empty / whitespace = null (clear the limit).
 * Valid non-negative integer = the number.
 * Anything else = "invalid".
 *
 * String-form input matches react-hook-form's number-input convention
 * (kept as string until parse-on-submit per existing admin patterns).
 */
export function parseSpendingLimitInput(
  raw: string,
): number | null | "invalid" {
  if (raw.trim() === "") return null;
  if (!/^\d+$/.test(raw.trim())) return "invalid";
  const n = Number(raw);
  if (!Number.isInteger(n) || n < 0) return "invalid";
  return n;
}
